(function () {
    'use strict';

    angular.module("imApp").factory("travelWagesService", ['$ihttp', function ($ihttp) {
        let service = {
            getTravelWages: function (parms) {
                return $ihttp.post({
                    method: 1488,
                    parameters: parms || {}
                });
            },
            listTravelWages: function (parms) {
                return $ihttp.post({
                    method: 1487,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
